import apiClient from "@/services/api/apiClient"
import type { Company } from "./api"
const root = "/company-index"
export interface DiscoverySchedule {
  url: string
  enabled: boolean
  autoRepair: boolean
  nextDue: Date | null
  revision: number
}
export interface DiscoveryJob {
  id: string
  companyId: string
  companyName: string
  url: string
  kind: "discovery" | "repair"
  status:
    | "queued"
    | "running"
    | "completed"
    | "partial"
    | "failed"
    | "cancelled"
  createdAt: Date
  candidateIds: string[]
  errorCode: string | null
}
export interface IndexNotification {
  id: string
  companyId: string
  companyName: string
  kind: string
  message: string
  createdAt: Date
  read: boolean
}
export const operations = {
  batch: async (items: { name: string; website: string }[]) =>
    (
      await apiClient.post<{ items: { company: Company; created: boolean }[] }>(
        `${root}/companies/batch`,
        { items },
      )
    ).data,
  list: async () =>
    (
      await apiClient.get<{
        jobs: DiscoveryJob[]
        notifications: IndexNotification[]
      }>(`${root}/operations`)
    ).data,
  schedule: async (id: string) =>
    (
      await apiClient.get<DiscoverySchedule>(
        `${root}/companies/${id}/discovery-schedule`,
      )
    ).data,
  configure: async (
    id: string,
    body: {
      url: string
      enabled: boolean
      autoRepair: boolean
      expectedRevision: number
    },
  ) =>
    (
      await apiClient.put<DiscoverySchedule>(
        `${root}/companies/${id}/discovery-schedule`,
        body,
      )
    ).data,
  enqueue: async (id: string, url?: string) =>
    (
      await apiClient.post<DiscoveryJob>(`${root}/companies/${id}/jobs`, {
        kind: "discovery",
        ...(url ? { url } : {}),
      })
    ).data,
  cancel: async (id: string) =>
    (await apiClient.post<DiscoveryJob>(`${root}/jobs/${id}/cancel`, {})).data,
  acknowledge: async (id: string) =>
    (
      await apiClient.post<{ ok: boolean }>(
        `${root}/notifications/${id}/ack`,
        {},
      )
    ).data,
}
